import { Injectable } from '@angular/core';
import { LifecycleRuleset } from '@r1-compass-library/models/lifecycle-rules/lifecycle-ruleset.model';
import { LifecycleRulesetSearch } from '@r1-compass-library/models/search/lifecycle-ruleset-search.model';
import { AssetRestService } from './rest/asset-rest.service';
import { Environment } from '@r1-compass-library/environments/environment';

@Injectable({ providedIn: 'root' })
export class LifecycleRulesetService extends AssetRestService<LifecycleRuleset, LifecycleRulesetSearch> {
    protected override BASE_URL: string = Environment.baseUrl + '/frontend/lifecycle-rulesets';
    protected override TARGET_OBJECT = 'lifecycle-ruleset';

    processNamePrefix = 'LifecycleRulesetService';
}
